import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    count = -1,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.orgPartner.myOrgGetPartnerList, {
        count,
    }, options);
    if (error) return { error, status };
    return content || {};
};
